module.exports = __webpack_public_path__ + "img/Rectangle 20.4b80f442.png";